import React from "react";

const ColorCalendar = ({ color = "#FF7D1E" }) => {
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.625 0C10.9702 0 11.25 0.279822 11.25 0.625V3.95833C11.25 4.30351 10.9702 4.58333 10.625 4.58333C10.2798 4.58333 10 4.30351 10 3.95833V2.91667H6.875C6.52982 2.91667 6.25 2.63684 6.25 2.29167C6.25 1.94649 6.52982 1.66667 6.875 1.66667H10V0.625C10 0.279822 10.2798 0 10.625 0ZM0 7.29167C0 6.94649 0.279822 6.66667 0.625 6.66667H15.625C15.9702 6.66667 16.25 6.94649 16.25 7.29167V14.7917C16.25 16.0573 15.224 17.0833 13.9583 17.0833H2.29167C1.02602 17.0833 0 16.0574 0 14.7917V7.29167ZM1.25 7.91667V14.7917C1.25 15.367 1.71636 15.8333 2.29167 15.8333H13.9583C14.5337 15.8333 15 15.367 15 14.7917V7.91667H1.25Z"
        fill={color}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.29167 2.91667C1.71637 2.91667 1.25 3.38304 1.25 3.95833V7.29167C1.25 7.63685 0.970178 7.91667 0.625 7.91667C0.279822 7.91667 0 7.63685 0 7.29167V3.95833C0 2.69268 1.02601 1.66667 2.29167 1.66667H3.95833C4.30351 1.66667 4.58333 1.94649 4.58333 2.29167C4.58333 2.63684 4.30351 2.91667 3.95833 2.91667H2.29167Z"
        fill={color}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.95833 0C4.30351 0 4.58333 0.279822 4.58333 0.625V3.95833C4.58333 4.30351 4.30351 4.58333 3.95833 4.58333C3.61316 4.58333 3.33333 4.30351 3.33333 3.95833V0.625C3.33333 0.279822 3.61316 0 3.95833 0Z"
        fill={color}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.9167 2.29167C12.9167 1.94649 13.1965 1.66667 13.5417 1.66667H13.9583C15.224 1.66667 16.25 2.69269 16.25 3.95833V7.29167C16.25 7.63685 15.9702 7.91667 15.625 7.91667C15.2798 7.91667 15 7.63685 15 7.29167V3.95833C15 3.38303 14.5336 2.91667 13.9583 2.91667H13.5417C13.1965 2.91667 12.9167 2.63684 12.9167 2.29167Z"
        fill={color}
      />
    </svg>
  );
};

export default ColorCalendar;
